(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-it-works"] && !Shopify.designMode) return;
  try {
    
(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  function initialize(root) {
    root.querySelectorAll('.ec-how [data-ec-autoplay]').forEach(block => {
      if (block.dataset.ecReady) return;
      const video = block.querySelector('video');
      if (!video) return;
      block.dataset.ecReady = 'true';
      const button = block.querySelector('[data-ec-toggle]');
      const section = block.closest('.ec-how');
      const auto = block.dataset.ecAutoplay === 'true';
      let userPaused = false;
      const sync = () => {
        if (button) button.textContent = video.paused ? section.dataset.playLabel : section.dataset.pauseLabel;
      };
      if (!auto || reduced.matches) video.controls = true;
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          if (video.paused) { userPaused = false; video.play().catch(() => {}); }
          else { userPaused = true; video.pause(); }
        });
      }
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) video.pause();
          else if (auto && !reduced.matches && !userPaused) video.play().catch(() => {});
        });
      }, {threshold: 0.2});
      observer.observe(video);
      const motionChange = () => { if (reduced.matches) video.pause(); };
      reduced.addEventListener('change', motionChange);
      const unload = event => {
        if (!event.target.contains(block)) return;
        observer.disconnect();
        reduced.removeEventListener('change', motionChange);
        document.removeEventListener('shopify:section:unload', unload);
      };
      document.addEventListener('shopify:section:unload', unload);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retail-b2b-order"]) return;
  try {
    
  (() => {
    document.querySelectorAll('.retail-b2b-order:not([data-retail-initialized])').forEach((section) => {
      section.dataset.retailInitialized = 'true';
      const status = section.querySelector('[data-retail-status]');
      const setStatus = (message) => { if (status) status.innerHTML = message; };
      const addItems = async (inputs, button) => {
        const items = [...inputs].map((input) => ({ id: Number(input.dataset.variantId), quantity: Number(input.value) })).filter((item) => item.quantity > 0);
        if (!items.length) { setStatus('Choose at least one quantity before adding to cart.'); return; }
        setStatus('Adding selected items…');
        try {
          const response = await fetch(section.dataset.cartAddUrl + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const added = await response.json();
          if (!response.ok || added.status) throw new Error();
          if (typeof window.monster_refresh === 'function') await window.monster_refresh(false);
          [...inputs].forEach((input) => { input.value = 0; });
          if (button) button.classList.add('is-added');
          setStatus('Added to cart. <a href="' + section.dataset.cartUrl + '">View cart</a>');
        } catch (error) { setStatus('We could not add those items. Please try again.'); }
      };
      section.querySelectorAll('[data-retail-quantity-step]').forEach((button) => button.addEventListener('click', () => {
        const input = button.closest('.retail-b2b-quantity-control').querySelector('[data-retail-quantity]');
        if (!input || input.disabled) return;
        if (button.dataset.retailQuantityStep === 'up') input.stepUp();
        if (button.dataset.retailQuantityStep === 'down') input.stepDown();
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      section.querySelectorAll('[data-retail-add-variant]').forEach((button) => button.addEventListener('click', () => addItems(section.querySelectorAll('[data-retail-quantity][data-variant-id="' + button.dataset.retailAddVariant + '"]'), button)));
      const landing = section.dataset.landingHandle;
      if (landing && !window.location.hash) {
        const target = section.querySelector('#retail-card-' + CSS.escape(landing));
        if (target) window.setTimeout(() => target.scrollIntoView({ block: 'start', behavior: 'instant' }), 80);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
